import React, { useEffect, useState, useMemo } from "react";
// import "./Usermanagement.css"; // Import the CSS file
import { Link } from "react-router-dom";

const Logisticsuserdetails = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();          // allows you to cancel on unmount

        const fetchUsers = async () => {
            try {
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/user/getallusers",
                    { signal: controller.signal }               // no headers ⇒ no Authorization
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const fetchedData = await res.json();

                const dataWithSno = fetchedData.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    orders: typeof item.orders === "number" ? item.orders : 0,
                    last: item.lastOrderDate || item.last || "N/A",
                    statusAsDeliveryAgent:
                        item.status || item.statusAsDeliveryAgent || "N/A",
                }));

                setData(dataWithSno);
            } catch (err) {
                // Only log real errors; ignore AbortError from unmount
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            }
        };

        fetchUsers();

        // cleanup: abort fetch if component unmounts early
        return () => controller.abort();
    }, []);

    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                (user.statusAsDeliveryAgent && user.statusAsDeliveryAgent.toLowerCase() === selectedStatusFilter.toLowerCase());
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });
    }, [data, selectedStatusFilter, selectedCategoryFilter]);

    const openModal = (user) => setSelectedCustomer(user);
    const closeModal = () => setSelectedCustomer(null);

    const dynamicMainContentStyle = () => {
        let marginLeft = "0px";
        if (screenWidth >= 1400) marginLeft = "0px";
        else if (screenWidth >= 1200) marginLeft = "0px";
        else if (screenWidth >= 992) marginLeft = "0px";
        else if (screenWidth < 768) marginLeft = "0px";
        return {
            marginLeft: marginLeft,
            paddingRight: screenWidth < 768 ? "0px" : "0px",
            boxSizing: "border-box",
        };
    };

    const handleExport = () => {
        // Prevent exporting if there's no data
        if (filteredData.length === 0) {
            alert("There is no data to export based on the current filters.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        // Match table columns: S.NO, Customer ID, Name, Email, Category, Subscription, Phone Number, Total Orders, Last Order Date, Status
        const headers = [
            "S.NO",
            "Customer ID",
            "Name",
            "Email",
            "Category",
            "Subscription",
            "Phone Number",
            "Total Orders",
            "Last Order Date",
            "Status"
        ];

        const csvRows = filteredData.map((user, index) => [
            index + 1,
            user.userId || 'N/A',
            user.userName || 'N/A',
            user.emailId || 'N/A',
            user.category || 'N/A',
            user.subscription || 'N/A',
            user.mobileNumber || 'N/A',
            user.orders !== undefined ? user.orders : 'N/A',
            user.last || 'N/A',
            user.statusAsDeliveryAgent || 'N/A'
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10 col-md-12 col-sm-12 col-xs-12">

                    <div className="user-management-page" style={{ overflowY: "auto", height: "100vh", scrollbarWidth: "thin", marginTop: "135px" }}>
                        <div className="user-management-container" style={dynamicMainContentStyle()}>
                            <p className="breadcrumb maamaas-home-bredcum or7"
                                style={{
                                    position: "fixed",
                                    top: "80px",
                                    left: "265px",
                                    width: "100%",
                                    backgroundColor: "#fff",
                                    // zIndex: 1000,
                                    padding: "10px 0",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    margin: 0,
                                }}
                            >
                                <Link
                                    to="/Homes"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Home
                                </Link>

                                <span className="separator"> &gt; </span>
                                <span
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    <Link

                                        style={{
                                            color: "purple",
                                            fontWeight: "bold",
                                            textDecoration: "none",
                                        }}
                                    >
                                        User_Management
                                    </Link>
                                </span>
                                <span className="separator"> &gt; </span>
                                <span
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Logistics & Supply
                                </span>
                            </p>

                            <div className="row g-2 mb-1 align-items-center me-0">


                                <div className="col-md-auto col-12">
                                    <select
                                        className="form-select"
                                        value={selectedStatusFilter}
                                        onChange={(e) => setSelectedStatusFilter(e.target.value)}
                                        aria-label="Filter by status"
                                    >
                                        <option value="">Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>


                                <div className="col-md col-12">

                                    <div className="d-flex justify-content-start justify-content-md-end">
                                        <button className="btn" onClick={handleExport} style={{ backgroundColor: '#b15cd6', color: '#fff' }}>
                                            Export
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <div className="user-table-wrapper ">
                                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>S.NO</th>
                                            <th style={tableHeaderStyle}>Name</th>
                                            <th style={tableHeaderStyle}>User ID</th>
                                            <th style={tableHeaderStyle}>Email</th>
                                            <th style={tableHeaderStyle}>Category</th>
                                            <th style={tableHeaderStyle}>Phone Number</th>
                                            <th style={tableHeaderStyle}>Total Orders</th>
                                            <th style={tableHeaderStyle}>Last Order Date</th>
                                            <th style={tableHeaderStyle}>Status</th>
                                            <th style={tableHeaderStyle}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((user, index) => (
                                                <tr
                                                    key={user.userId || user.sno}
                                                    style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                                                >
                                                    <td style={tableCellStyle}>{user.sno}</td>
                                                    <td style={tableCellStyle}>{user.userName}</td>
                                                    <td style={tableCellStyle}>{user.userId}</td>
                                                    <td style={tableCellStyle}>{user.emailId}</td>
                                                    <td style={tableCellStyle}>{user.category}</td>
                                                    <td style={tableCellStyle}>{user.mobileNumber}</td>
                                                    <td style={tableCellStyle}>{user.orders}</td>
                                                    <td style={tableCellStyle}>{user.last}</td>
                                                    <td style={tableCellStyle}>{user.statusAsDeliveryAgent}</td>
                                                    <td style={tableCellStyle}>
                                                        <button
                                                            style={actionButtonStyle}
                                                            onClick={() => openModal(user)}
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" style={noDataStyle}>
                                                    {data.length === 0
                                                        ? "Loading data or no customers found."
                                                        : "No customers match the current filters."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            </div>

                            {selectedCustomer && (
                                <div className="user-modal-overlay">
                                    <div className="user-modal-content">
                                        <h2 className="user-modal-title">Customer Details</h2>
                                        <p><strong>ID:</strong> {selectedCustomer.userId}</p>
                                        <p><strong>Name:</strong> {selectedCustomer.userName}</p>
                                        <p><strong>Email:</strong> {selectedCustomer.emailId}</p>
                                        <p><strong>Category:</strong> {selectedCustomer.category}</p>
                                        <p><strong>Phone:</strong> {selectedCustomer.mobileNumber}</p>
                                        <p><strong>Total Orders:</strong> {selectedCustomer.orders}</p>
                                        <p><strong>Last order:</strong> {selectedCustomer.last}</p>
                                        <p><strong>Status:</strong> {selectedCustomer.statusAsDeliveryAgent}</p>
                                        <div className="user-modal-actions">
                                            <button onClick={closeModal} className="user-modal-close-button">
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

const actionButtonStyle = {
    padding: "4px 10px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "0.85rem",
    cursor: "pointer",
};


export default Logisticsuserdetails;